import { ChangeDetectionStrategy, Component, Input, signal, input } from '@angular/core';

import type { IconName } from '../../../../common/icon/icons.type';
import { BadgeComponent } from '../../../badge/badge.component';
import type { BadgeColor } from '../../../badge/badge.types';
import { BoxComponent } from '../../../box/box.component';
import { HeadingComponent } from '../../../heading/heading.component';
import { IconToken } from '../../../icon/directives/icon-color.directive';
import { IconComponent, type IconSize } from '../../../icon/icon.component';
import {
  BackgroundColors,
  IconContainerComponent,
} from '../../../icon-container/icon-container.component';

@Component({
  selector: 'rt-new-item-button',
  templateUrl: 'new-item-button.component.html',
  styleUrls: ['./new-item-button.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BadgeComponent, BoxComponent, HeadingComponent, IconComponent, IconContainerComponent],
  host: {
    '(mouseenter)': 'isHovered.set(true)',
    '(mouseleave)': 'isHovered.set(false)',
  },
})
export class NewItemButtonComponent {
  public readonly icon = input<IconName>(undefined!);
  public readonly iconSize = input<IconSize>('small');
  public readonly iconColor = input<IconToken>(undefined!);
  public readonly backgroundHoverColor = input<BackgroundColors>('colorBgPrimarySubduedHover');
  public readonly heading = input<string>('');
  public readonly subheading = input<string>('');
  public readonly badgeVariant = input<BadgeColor>(undefined!);
  public readonly disabled = input(false);
  public readonly hasArrowOnHover = input(true);
  public readonly iconCentered = input(false);

  @Input() public iconBackground: BackgroundColors;
  @Input() public badgeText?: string;

  public isHovered = signal(false);
}
